import React from "react";
import { Button } from "../ui/Button";

interface PaginationFooterProps {
  totalItems: number;
  filteredTotal: number;
  currentPage: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export const PaginationFooter: React.FC<PaginationFooterProps> = ({
  totalItems,
  filteredTotal,
  currentPage,
  itemsPerPage,
  onPageChange,
  className,
}) => {
  const totalPages = Math.ceil(filteredTotal / itemsPerPage) || 1;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Guard against out of bounds if filteredTotal is 0
  const showingStart = filteredTotal > 0 ? indexOfFirstItem + 1 : 0;
  const showingEnd = Math.min(indexOfLastItem, filteredTotal);

  return (
    <div
      className={`px-6 py-3 border-t border-gray-100 bg-gray-50 flex items-center justify-between ${
        className || ""
      }`}
    >
      <p className="text-xs text-gray-500">
        Showing{" "}
        <span className="font-medium text-gray-700">{showingStart}</span> -{" "}
        <span className="font-medium text-gray-700">{showingEnd}</span> of{" "}
        <span className="font-medium text-gray-700">{filteredTotal}</span>{" "}
        results
      </p>
      <div className="flex gap-2 items-center">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className="h-8 w-8 p-0 border-gray-300 hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50"
        >
          &lt;
        </Button>
        <span className="text-xs font-medium text-gray-600 px-2">
          Page {currentPage} of {totalPages}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage >= totalPages}
          className="h-8 w-8 p-0 border-gray-300 hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50"
        >
          &gt;
        </Button>
      </div>
    </div>
  );
};
